module.exports = __webpack_public_path__ + "img/35-hbcsjs.16852074.png";